import createCache from '@emotion/cache';

const getEmotionCache = () => createCache({ key: 'css', prepend: true });

export default getEmotionCache;
